import React, { useState, useRef, useEffect } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { IconButton, Tooltip } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";

export default function PersonnelId({ personnelId }) {
  const [open, setOpen] = useState(false);
  const timerRef = useRef(null);

  const handleTooltipOpen = () => {
    setOpen(true);
    if (personnelId) {
      navigator.clipboard.writeText(String(personnelId));
    }
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      setOpen(false);
    }, 1500);
  };

  useEffect(() => {
    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, []);

  return (
    <Box sx={{ pb: "10px", display: "flex", gap: "20px" }}>
      <Typography sx={{ fontSize: "25px" }}>{personnelId}</Typography>
      <Tooltip
        PopperProps={{ disablePortal: true }}
        open={open}
        disableFocusListener
        disableHoverListener
        disableTouchListener
        title="コピーしました"
        placement="right"
        arrow
      >
        <IconButton onClick={handleTooltipOpen} size="small">
          <ContentCopyIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    </Box>
  );
}